import TaxModel from "../models/TaxModel";
import axios from "axios";

export default class apiTax {

    static async getAll(): Promise<Array<TaxModel>> {
        let models = new Array<TaxModel>();

        let respone = await axios.post("api/Tax/getAll");
        respone.data.models.forEach((item: any) =>
            models.push(TaxModel.from(item))
        );        

        return models;
    }

    static async create(): Promise<TaxModel> {
        let respone = await axios.post("api/Tax/create");
        let model = TaxModel.from(respone.data.model)            
        return model;
    }

    static async save(tax: TaxModel): Promise<void> {
        let respone = await axios.post("api/Tax/save", {
            model: tax,
        });
    }

    static async delete(taxId: string): Promise<void> {
        let respone = await axios.post("api/Tax/delete", {
            ModelId: taxId,
        });
    }
}
